export const SENSOR_DATA_WIDGET_DISPLAY = Object.freeze({
  GRAPH_AND_TABLE: 'GRAPH_AND_TABLE',
  GRAPH_ONLY: 'GRAPH_ONLY',
  TABLE_ONLY: 'TABLE_ONLY',
});

export const SENSOR_DATA_SOURCE_TYPE = Object.freeze({
  HIGH_LOW: 'HIGH_LOW',
  METRIC_GROUP: 'METRIC_GROUP',
});

export const SENSOR_DATA_TIME_RANGE = Object.freeze({
  ONE_DAY: 'ONE_DAY',
  ONE_WEEK: 'ONE_WEEK',
  THIRTY_DAY: 'THIRTY_DAY',
});

export const TIME_RANGE_OPTIONS = [
  { value: SENSOR_DATA_TIME_RANGE.ONE_DAY, label: '1 day', days: 1 },
  { value: SENSOR_DATA_TIME_RANGE.ONE_WEEK, label: '1 Week', days: 7 },
  { value: SENSOR_DATA_TIME_RANGE.THIRTY_DAY, label: '30 day', days: 30 },
];

export const DISPLAY_OPTIONS = [
  { value: SENSOR_DATA_WIDGET_DISPLAY.GRAPH_AND_TABLE, label: 'Display Graph & Data Table' },
  { value: SENSOR_DATA_WIDGET_DISPLAY.GRAPH_ONLY, label: 'Display Graph Only' },
  { value: SENSOR_DATA_WIDGET_DISPLAY.TABLE_ONLY, label: 'Display Data Table Only' },
];

export const SOURCE_TYPE_OPTIONS = [
  { value: SENSOR_DATA_SOURCE_TYPE.HIGH_LOW, label: 'High & Low Temperature Trends' },
  { value: SENSOR_DATA_SOURCE_TYPE.METRIC_GROUP, label: 'Custom Data Group' },
];

export const SENSOR_DATA_DEFAULT_CONTEXT = Object.freeze({
  sourceType: SENSOR_DATA_SOURCE_TYPE.HIGH_LOW,
  metricGroupId: null,
  displayType: SENSOR_DATA_WIDGET_DISPLAY.GRAPH_AND_TABLE,
  timeRange: SENSOR_DATA_TIME_RANGE.ONE_DAY,
});

export const isGraphVisible = (displayType) => (
  displayType === SENSOR_DATA_WIDGET_DISPLAY.GRAPH_AND_TABLE
  || displayType === SENSOR_DATA_WIDGET_DISPLAY.GRAPH_ONLY
);

export const isTableVisible = (displayType) => (
  displayType === SENSOR_DATA_WIDGET_DISPLAY.GRAPH_AND_TABLE
  || displayType === SENSOR_DATA_WIDGET_DISPLAY.TABLE_ONLY
);
